// extracted by mini-css-extract-plugin
export default {"Color":"styles_Color__UuzWr","overlay":"styles_overlay__d9etT","active":"styles_active__6+ype","color":"styles_color__OMdED","code":"styles_code__cIzEu"};